import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const CogIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 26 26">
      <g fill="none">
        <path
          stroke="currentColor"
          d="M9.807 3.793l.294-.096.045-.307L10.57.5h4.861l.424 2.889.045.306.295.096a10.057 10.057 0 013.42 1.924l.228.195.28-.11 2.801-1.094 2.42 4.078-2.354 1.797-.25.191.064.308a9.495 9.495 0 010 3.838l-.063.308.25.19 2.353 1.798-2.42 4.078-2.8-1.094-.28-.11-.227.196a10.056 10.056 0 01-3.422 1.925l-.295.096-.045.306-.424 2.889h-4.86l-.425-2.89-.045-.306-.294-.097a10.056 10.056 0 01-3.42-1.925l-.228-.195-.28.109-2.803 1.095-2.42-4.077 2.359-1.801.25-.191-.064-.307a9.498 9.498 0 010-3.831l.064-.308-.25-.19L.658 8.785l2.419-4.078L5.88 5.803l.28.109.228-.196a10.057 10.057 0 013.418-1.923z"
        />
        <circle cx="13" cy="13" r="6" stroke="currentColor" />
      </g>
    </SvgIcon>
  );
};
